module.exports = __webpack_public_path__ + "static/media/bg3.7f7796d8.jpg";